"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ports_1 = require("@/store/ducks/ports");
const ports_2 = require("@/services/ports");
function listPortsUseCase() {
    return (dispatch) => {
        dispatch((0, ports_1.getPorts)());
        return (0, ports_2.getPorts)()
            .then((ports) => {
            dispatch((0, ports_1.getPortsSuccess)(ports));
        })
            .catch(() => {
            dispatch((0, ports_1.getPortsError)());
        });
    };
}
exports.default = listPortsUseCase;
